import { IFWPauseAdSlotParams } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdSlotParams';
import { IFWPauseAdSlotDimensions } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdSlotDimensions';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel PauseAds Constants
 */
export class FreewheelPauseAdConstants {
	private static _instance: FreewheelPauseAdConstants = new FreewheelPauseAdConstants();

	constructor() {
		if ( FreewheelPauseAdConstants._instance ) {
			throw new Error(
				this.name +
				' is a Singleton and can only be accessed through ' +
				this.name +
				'.getInstance()'
			);
		}
		FreewheelPauseAdConstants._instance = this;
	}

	get name(): string {
		return 'FreewheelPauseAdConstants';
	}

	// IMPORTANT: all hardcoded values are specified in https://docs.google.com/spreadsheets/d/1trwgwrp52kR-7wc9WL1X9GM1zp8Y1oVHrqSiT49H6NI/edit#gid=2030777926

	/**
	 * @description Returns Capabilities Flag.
	 * @return {string}
	 */
	get capabilitiesFlag(): string {
		return '+amcb+emcr+dtrd+slcb+vicb+fbad+sync+nucr+aeti';
	}

	/**
	 * @description Returns Output / Response
	 * @return {string}
	 */
	get response(): string {
		return 'vast4';
	}

	/**
	 * @description Returns Page View
	 * @return {string}
	 */
	get pageView(): string {
		return `${this.randomTag}`;
	}

	/**
	 * @description Returns Video Player
	 * @return {string}
	 */
	get videoPlayer(): string {
		return `${this.randomTag}`;
	}

	/**
	 * @description Returns a random 10-16 digits number.
	 * @return {number}
	 */
	get randomTag(): number {
		const max: number = 10 ** 16;
		const min: number = 10 ** 9;
		return Math.floor( Math.random() * ( max - min - 2 ) ) + min;
	}

	/**
	 * @description Returns Freewheel common set Slot parameters for Client Side Calls
	 * @return {IFWPauseAdSlotParams}
	 */
	get commonSlotParams(): IFWPauseAdSlotParams {
		return {
			maxa: '1',
			slid: 'pause_ads-1018x674',
			ptgt: 'a',
			tpcl: 'PAUSE_MIDROLL',
			slau: 'PAUSE_AD'
		} as IFWPauseAdSlotParams;
	}

	/**
	 * @description Returns Freewheel Desktop Slot dimensions
	 * @return {IFWPauseAdSlotDimensions}
	 */
	get desktopSlotDimensions(): IFWPauseAdSlotDimensions {
		return {
			w: '1018',
			h: '674'
		} as IFWPauseAdSlotDimensions;
	}

	/**
	 * @description Returns Freewheel STV Slot dimensions
	 * @return {IFWPauseAdSlotDimensions}
	 */
	get stvSlotDimensions(): IFWPauseAdSlotDimensions {
		return {
			w: '1018',
			h: '674'
		} as IFWPauseAdSlotDimensions;
	}

	public static getInstance(): FreewheelPauseAdConstants {
		return FreewheelPauseAdConstants._instance;
	}
}